import { useTranslation } from '@shared/core/i18n';

export const useSlapAdsRegistryTranslations = () => {
  const { t } = useTranslation('slapAdsRegistry');
  const messageVariants = t('messageVariants');
  return {
    messageVariants,
  };
};
